.dock {
  position: absolute;
  bottom: var(--chrome-inset);
  left: 50%;
  transform: translateX(-50%);
  z-index: var(--z-chrome);
  display: flex;
  gap: var(--space-1);
  padding: 5px;
  border-radius: var(--radius-lg);
  max-width: min(60vw, 720px);
  overflow-x: auto;
}

.item {
  gap: 6px;
  font-size: 12.5px;
}

.item[data-active='true'] {
  background: var(--focus-soft);
  border-color: var(--focus);
}

.item[data-minimized='true'] {
  color: var(--ink-faint);
}

.label {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}
